import React from 'react'
import Navbar from './Navbar'
function App() {
  return (
    <React.Fragment>
      <Navbar/>
    </React.Fragment>
  )
}

export default App
